export default "__VITE_ASSET__D_PuIXOL__"